export default __webpack_public_path__ + "static/media/service4.2576f8c3.png";